/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateEmailTemplateRequest,
  GetEmailTemplateDefinitionResponse,
  GetEmailTemplateResponse,
  GetUnreadNotificationCountResponse,
  PaginatedResultOfGetNotificationResponse,
  ProblemDetails,
  Result,
  ResultOfEmailNotificationResponse,
  UpdateEmailTemplateRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateEmailTemplateRequestFromJSON,
    CreateEmailTemplateRequestToJSON,
    GetEmailTemplateDefinitionResponseFromJSON,
    GetEmailTemplateDefinitionResponseToJSON,
    GetEmailTemplateResponseFromJSON,
    GetEmailTemplateResponseToJSON,
    GetUnreadNotificationCountResponseFromJSON,
    GetUnreadNotificationCountResponseToJSON,
    PaginatedResultOfGetNotificationResponseFromJSON,
    PaginatedResultOfGetNotificationResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfEmailNotificationResponseFromJSON,
    ResultOfEmailNotificationResponseToJSON,
    UpdateEmailTemplateRequestFromJSON,
    UpdateEmailTemplateRequestToJSON,
} from '../models/index';

export interface ApiNotificationsDeleteRequest {
    requestBody: Array<string>;
    xTenantID?: number;
}

export interface ApiNotificationsEmailTemplateDefinitionsGetRequest {
    xTenantID?: number;
}

export interface ApiNotificationsEmailTemplateIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiNotificationsEmailTemplateIdGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiNotificationsEmailTemplateIdPutRequest {
    id: number;
    updateEmailTemplateRequest: UpdateEmailTemplateRequest;
    xTenantID?: number;
}

export interface ApiNotificationsEmailTemplatePostRequest {
    createEmailTemplateRequest: CreateEmailTemplateRequest;
    xTenantID?: number;
}

export interface ApiNotificationsEmailTemplateTypeGetRequest {
    type: string;
    key?: string;
    xTenantID?: number;
}

export interface ApiNotificationsPutRequest {
    requestBody: Array<string>;
    xTenantID?: number;
}

export interface ApiNotificationsSendEmailPostRequest {
    xTenantID?: number;
    from?: string;
    to?: Array<string>;
    cc?: Array<string>;
    bcc?: Array<string>;
    subject?: string;
    textBody?: string;
    htmlBody?: string;
    sendAdminCopy?: boolean;
    files?: Array<Blob>;
}

export interface ApiNotificationsUserIdGetRequest {
    userId: number;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiNotificationsUserIdUnreadCountGetRequest {
    userId: number;
    xTenantID?: number;
}

export interface ApiNotificationsUserIdUnreadGetRequest {
    userId: number;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     * Deletes multiple notifications by their IDs.
     * Delete multiple notifications
     */
    async apiNotificationsDeleteRaw(requestParameters: ApiNotificationsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling apiNotificationsDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes multiple notifications by their IDs.
     * Delete multiple notifications
     */
    async apiNotificationsDelete(requestParameters: ApiNotificationsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiNotificationsDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all email template definitions
     * Get Email Template Definitions
     */
    async apiNotificationsEmailTemplateDefinitionsGetRaw(requestParameters: ApiNotificationsEmailTemplateDefinitionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetEmailTemplateDefinitionResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/email-template/definitions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetEmailTemplateDefinitionResponseFromJSON));
    }

    /**
     * Retrieves all email template definitions
     * Get Email Template Definitions
     */
    async apiNotificationsEmailTemplateDefinitionsGet(requestParameters: ApiNotificationsEmailTemplateDefinitionsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetEmailTemplateDefinitionResponse>> {
        const response = await this.apiNotificationsEmailTemplateDefinitionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an existing email template by its ID.
     * Delete Email Template
     */
    async apiNotificationsEmailTemplateIdDeleteRaw(requestParameters: ApiNotificationsEmailTemplateIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiNotificationsEmailTemplateIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/email-template/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an existing email template by its ID.
     * Delete Email Template
     */
    async apiNotificationsEmailTemplateIdDelete(requestParameters: ApiNotificationsEmailTemplateIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiNotificationsEmailTemplateIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves an email template by its ID
     * Get Email Template by ID
     */
    async apiNotificationsEmailTemplateIdGetRaw(requestParameters: ApiNotificationsEmailTemplateIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmailTemplateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiNotificationsEmailTemplateIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/email-template/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmailTemplateResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves an email template by its ID
     * Get Email Template by ID
     */
    async apiNotificationsEmailTemplateIdGet(requestParameters: ApiNotificationsEmailTemplateIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmailTemplateResponse> {
        const response = await this.apiNotificationsEmailTemplateIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing email template with the provided details.
     * Update Email Template
     */
    async apiNotificationsEmailTemplateIdPutRaw(requestParameters: ApiNotificationsEmailTemplateIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiNotificationsEmailTemplateIdPut().'
            );
        }

        if (requestParameters['updateEmailTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateEmailTemplateRequest',
                'Required parameter "updateEmailTemplateRequest" was null or undefined when calling apiNotificationsEmailTemplateIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/email-template/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEmailTemplateRequestToJSON(requestParameters['updateEmailTemplateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates an existing email template with the provided details.
     * Update Email Template
     */
    async apiNotificationsEmailTemplateIdPut(requestParameters: ApiNotificationsEmailTemplateIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiNotificationsEmailTemplateIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new email template with the provided details.
     * Create Email Template
     */
    async apiNotificationsEmailTemplatePostRaw(requestParameters: ApiNotificationsEmailTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createEmailTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'createEmailTemplateRequest',
                'Required parameter "createEmailTemplateRequest" was null or undefined when calling apiNotificationsEmailTemplatePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/email-template`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmailTemplateRequestToJSON(requestParameters['createEmailTemplateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new email template with the provided details.
     * Create Email Template
     */
    async apiNotificationsEmailTemplatePost(requestParameters: ApiNotificationsEmailTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiNotificationsEmailTemplatePostRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves an email template by its type (e.g. \'Class\',\'Student\') and Key (e.g. \'CLASS_BULK_EMAIL\')
     * Get Email Template by Type and Key
     */
    async apiNotificationsEmailTemplateTypeGetRaw(requestParameters: ApiNotificationsEmailTemplateTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetEmailTemplateResponse>>> {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling apiNotificationsEmailTemplateTypeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/email-template/{type}`;
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetEmailTemplateResponseFromJSON));
    }

    /**
     * Retrieves an email template by its type (e.g. \'Class\',\'Student\') and Key (e.g. \'CLASS_BULK_EMAIL\')
     * Get Email Template by Type and Key
     */
    async apiNotificationsEmailTemplateTypeGet(requestParameters: ApiNotificationsEmailTemplateTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetEmailTemplateResponse>> {
        const response = await this.apiNotificationsEmailTemplateTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks the specified notifications as read for the current user.
     * Mark notifications as read
     */
    async apiNotificationsPutRaw(requestParameters: ApiNotificationsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling apiNotificationsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Marks the specified notifications as read for the current user.
     * Mark notifications as read
     */
    async apiNotificationsPut(requestParameters: ApiNotificationsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiNotificationsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Sends an email using the provided details.
     * Sends an email
     */
    async apiNotificationsSendEmailPostRaw(requestParameters: ApiNotificationsSendEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfEmailNotificationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['from'] != null) {
            formParams.append('From', requestParameters['from'] as any);
        }

        if (requestParameters['to'] != null) {
            formParams.append('To', requestParameters['to']!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        if (requestParameters['cc'] != null) {
            formParams.append('Cc', requestParameters['cc']!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        if (requestParameters['bcc'] != null) {
            formParams.append('Bcc', requestParameters['bcc']!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        if (requestParameters['subject'] != null) {
            formParams.append('Subject', requestParameters['subject'] as any);
        }

        if (requestParameters['textBody'] != null) {
            formParams.append('TextBody', requestParameters['textBody'] as any);
        }

        if (requestParameters['htmlBody'] != null) {
            formParams.append('HtmlBody', requestParameters['htmlBody'] as any);
        }

        if (requestParameters['sendAdminCopy'] != null) {
            formParams.append('SendAdminCopy', requestParameters['sendAdminCopy'] as any);
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('Files', element as any);
            })
        }


        let urlPath = `/api/notifications/send-email`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfEmailNotificationResponseFromJSON(jsonValue));
    }

    /**
     * Sends an email using the provided details.
     * Sends an email
     */
    async apiNotificationsSendEmailPost(requestParameters: ApiNotificationsSendEmailPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfEmailNotificationResponse | null | undefined > {
        const response = await this.apiNotificationsSendEmailPostRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Retrieves all notifications for a specific user
     * Get All Notifications
     */
    async apiNotificationsUserIdGetRaw(requestParameters: ApiNotificationsUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetNotificationResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiNotificationsUserIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetNotificationResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all notifications for a specific user
     * Get All Notifications
     */
    async apiNotificationsUserIdGet(requestParameters: ApiNotificationsUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetNotificationResponse> {
        const response = await this.apiNotificationsUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the total number of unread notifications for the authenticated user. Callers may only read their own count.
     * Get Unread Notification Count
     */
    async apiNotificationsUserIdUnreadCountGetRaw(requestParameters: ApiNotificationsUserIdUnreadCountGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUnreadNotificationCountResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiNotificationsUserIdUnreadCountGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/{userId}/unread-count`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUnreadNotificationCountResponseFromJSON(jsonValue));
    }

    /**
     * Returns the total number of unread notifications for the authenticated user. Callers may only read their own count.
     * Get Unread Notification Count
     */
    async apiNotificationsUserIdUnreadCountGet(requestParameters: ApiNotificationsUserIdUnreadCountGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUnreadNotificationCountResponse> {
        const response = await this.apiNotificationsUserIdUnreadCountGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves unread notifications for a specific user
     * Get Unread Notifications
     */
    async apiNotificationsUserIdUnreadGetRaw(requestParameters: ApiNotificationsUserIdUnreadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetNotificationResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling apiNotificationsUserIdUnreadGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/notifications/{userId}/unread`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetNotificationResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves unread notifications for a specific user
     * Get Unread Notifications
     */
    async apiNotificationsUserIdUnreadGet(requestParameters: ApiNotificationsUserIdUnreadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetNotificationResponse> {
        const response = await this.apiNotificationsUserIdUnreadGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
